var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66 4.358a3.302 3.302 0 1 0 0 6.604 3.302 3.302 0 0 0 0-6.604ZM6.29 7.66a1.37 1.37 0 1 1 2.739 0 1.37 1.37 0 0 1-2.739 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.606A3.606 3.606 0 0 1 3.606 0h16.787A3.606 3.606 0 0 1 24 3.606v16.788A3.606 3.606 0 0 1 20.393 24H3.606A3.606 3.606 0 0 1 0 20.394V3.606Zm3.606-1.19a1.19 1.19 0 0 0-1.19 1.19v16.788c0 .232.066.45.182.633L15.523 8.1a2.819 2.819 0 0 1 4.069.087l1.991 2.168v-6.75a1.19 1.19 0 0 0-1.19-1.19H3.606Zm16.787 19.168H5.457L17.231 9.81a.403.403 0 0 1 .582.012l3.77 4.105v6.467a1.19 1.19 0 0 1-1.19 1.19Z",
    fill: "currentColor"
  })));
};
export default SvgImage;